import React from "react";
import { Button } from "antd";
import {
  PlusOutlined,
  RocketOutlined,
  BarChartOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import { l } from "../../../libs/localization";
import "./DashboardEmptyState.scss";

const DashboardEmptyState = ({ onAddCompany }) => {
  return (
    <div className="dashboard-empty-state">
      <div className="dashboard-empty-state__content">
        <div className="dashboard-empty-state__visual">
          <div className="dashboard-empty-state__icon-group">
            <div className="dashboard-empty-state__icon dashboard-empty-state__icon--1">
              <BarChartOutlined />
            </div>
            <div className="dashboard-empty-state__icon dashboard-empty-state__icon--2">
              <RocketOutlined />
            </div>
            <div className="dashboard-empty-state__icon dashboard-empty-state__icon--3">
              <LineChartOutlined />
            </div>
          </div>
          <div className="dashboard-empty-state__glow" />
        </div>

        <h2 className="dashboard-empty-state__title">
          {l("PAGES.DASHBOARD.EMPTY_STATE.TITLE")}
        </h2>

        <p className="dashboard-empty-state__description">
          {l("PAGES.DASHBOARD.EMPTY_STATE.DESCRIPTION")}
        </p>

        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          onClick={onAddCompany}
          className="dashboard-empty-state__button"
        >
          {l("PAGES.DASHBOARD.EMPTY_STATE.BUTTON")}
        </Button>
      </div>
    </div>
  );
};

export default DashboardEmptyState;
